const PAGE_ITEM_TYPES = Object.freeze({
  first: "first",
  previous: "previous",
  ellipsis: "ellipsis",
  next: "next",
  last: "last",
} as const);

export default PAGE_ITEM_TYPES;
